import InstrutoresHorariosAdminPage from "@/Pages/Instrutores/InstrutoresHorariosAdminPage.vue";
import MeusHorariosPage from "@/Pages/Instrutores/MeusHorariosPage.vue";
import authService from "@/Services/AuthService";
import store from "@/store";

async function carregarUsuarioAtual() {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await authService.syncUserWithStore();
    currentUser = store.getters["Auth/user"];
  }

  return currentUser;
}

function possuiPermissao(currentUser, permissions = []) {
  if (currentUser?.roleName === "super-admin") return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return true;

  return permissions.some((permission) => currentUser?.permissions?.includes(permission));
}

function possuiPerfil(currentUser, allowedRoles = []) {
  return allowedRoles.includes(currentUser?.roleName);
}

async function redirecionarSemInstrutor(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  const allowedRoles = ["TI", "admin", "super-admin", "professor"];

  if (
    !possuiPerfil(currentUser, allowedRoles) ||
    !possuiPermissao(currentUser, ["instrutores.meusHorarios"]) ||
    !currentUser?.instrutor?.id
  ) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoAdmin(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  const allowedRoles = ["TI", "admin", "super-admin"];

  if (
    !possuiPerfil(currentUser, allowedRoles) ||
    !possuiPermissao(currentUser, ["instrutores.horarios"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

export default [
  {
    path: "/instrutores/meus-horarios",
    name: "instrutores.meusHorarios",
    component: MeusHorariosPage,
    beforeEnter: redirecionarSemInstrutor,
  },
  {
    path: "/instrutores/horarios",
    name: "instrutores.horarios",
    component: InstrutoresHorariosAdminPage,
    beforeEnter: redirecionarSemPermissaoAdmin,
  },
];
